import { OmneaError } from '@omnea-digital/toolbox'
import type { PermissionSetEntity } from '@omnea-app/authz'

type RecordPermissionsResponseDetail =
  | { reason: 'noBody'; entity: PermissionSetEntity; recordId: string }
  | { reason: 'answeredForAnotherEntity'; entity: PermissionSetEntity; recordId: string; answeredFor: PermissionSetEntity }

export class RecordPermissionsResponseError extends OmneaError<
  'RecordPermissionsResponseError',
  RecordPermissionsResponseDetail
> {
  readonly type = 'RecordPermissionsResponseError'

  constructor(detail: RecordPermissionsResponseDetail) {
    super({ message: 'The permissions service did not answer for the record that was asked about', detail })
  }
}
